import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Media} from "@models";
import {NotificationService, SimUtilityExtendedService, TypePredicates} from "@services";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

export interface DialogData_ImageDialogMediaInput extends MatDialogDataBaseInput {
	type: "media";
	media: Media;
}

export interface DialogData_ImageDialogUrlInput extends MatDialogDataBaseInput {
	type: "url";
	mediaName: string;
	mediaUrl: string;
}

export type DialogData_ImageDialogInput = DialogData_ImageDialogMediaInput | DialogData_ImageDialogUrlInput;

export interface DialogData_ImageDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-image-dialog",
	templateUrl: "./image-dialog.component.html",
	styleUrls: ["./image-dialog.component.scss"],
	standalone: false,
})
export class ImageDialogComponent extends BasicMaterialDialog<
	ImageDialogComponent,
	DialogData_ImageDialogInput,
	DialogData_ImageDialogOutput
> {
	T = Translations;
	SimUtilityExtendedService = SimUtilityExtendedService;
	TypePredicates = TypePredicates;
	imageLoadError: any;

	headerText: string;

	constructor(
		public simUtilityService: SimUtilityExtendedService,
		private _translate: TranslateService,
		_injector: Injector,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);

		switch (this.data.type) {
			case "media":
				this.headerText = this.data.media.name;
				break;
			case "url":
				this.headerText = this.data.mediaName;
				break;
		}
	}

	errorImg() {
		this._simNotificationService.notifyError(this._translate.instant(Translations.IMAGE_DIALOG_NOTIFYERROR));
		this.imageLoadError = true;
	}
}
